import {GetServiceCaseAdditionalInformationApiResponse} from '@dms/api/workshop';
import {EntityHeaderFlag} from '@dms/shared';

const ADDITIONAL_INFORMATION_FLAG_COLOR = 'neutral';

export function getAdditionalInformationFlags(
  additionalInformation: GetServiceCaseAdditionalInformationApiResponse
): EntityHeaderFlag[] {
  return (
    additionalInformation?.flatMap((information) =>
      information
        ? [
            {
              label: information.message,
              colorScheme: ADDITIONAL_INFORMATION_FLAG_COLOR,
              isSubtle: true,
            },
          ]
        : []
    ) ?? []
  );
}
